import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import Datetime from 'react-datetime';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import Input from 'components/react-validation/components/input';
import * as Vali from 'helper/validator-helper';
import { decimalFixed } from 'helper/unit-helper';
import Form from 'components/react-validation/components/form';
import Textarea from '../../components/react-validation/components/text-area';
import Submit from '../../components/react-validation/components/submit';
import * as LotActionType from '../../Lots/constants';
import * as WorkOrderActionType from '../constants';
import * as SubcontractorActionType from '../../Subcontractors/constants';

class AddBackCharge extends Component {

  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    tradeSelectList: PropTypes.array,
    userProfile: PropTypes.object,
    history: PropTypes.any,
    subcontractorSelectList: PropTypes.array,
    BackChargeProfile: PropTypes.object,
    toggleEditMode: PropTypes.func,
    backChargeId: PropTypes.any,
    WorkOrderProfile: PropTypes.object
  }

  constructor(props) {

    super(props);

    let rfsId = null;
    let workOrderId = null;
    let purchaseOrderId = null;
    let backChargeId = null;

    if (props.match.params.RFSID) {
      rfsId = props.match.params.RFSID;
    }

    if (props.match.params.WOID) {
      workOrderId = props.match.params.WOID;
    }

    if (props.match.params.POID) {
      purchaseOrderId = props.match.params.POID;
    }

    if (props.match.params.BCID) {
      backChargeId = props.match.params.BCID;
    }

    const { BackChargeProfile } = props;

    this.state = {
      rfsId,
      workOrderId,
      purchaseOrderId,
      backChargeId,
      trade: BackChargeProfile.trade ? {
        value: BackChargeProfile.trade.id,
        text: BackChargeProfile.trade.name,
        extensionValue: null,
        selected: false
      } : null,
      chargedTo: BackChargeProfile.subcontractor ? {
        value: BackChargeProfile.subcontractor.subcontractorId,
        text: BackChargeProfile.subcontractor.companyName,
        extensionValue: null,
        selected: false
      } : null
    };
  }

  componentDidMount() {
    this.fetWorkOrderById();
  }

  fetWorkOrderById = () => {
    this.props.dispatch({
      type: WorkOrderActionType.GET_WORK_ORDER_DETAIL_ASYNC,
      params: {
        woRefNo: this.state.workOrderId,
        rfsRefNo: this.state.rfsId
      },
      callback: (data) => {
        this.fetchTradeSelectList(data);
        this.fetchSubcontractor(data);
      }
    });
  }

  fetchTradeSelectList = (data) => {
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: data.requestDetail.lot.id,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      }
    });
  }

  fetchSubcontractor = (data) => {
    const {BackChargeProfile} = this.props;

    if (data) {
      this.props.dispatch({
        type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
        params: {
          projectId: data.requestDetail.project.id,
          lotId: data.requestDetail.lot.id,
          tradeId: BackChargeProfile.trade.id,
          param: {
            searchKey: '',
            selectedValue: ''
          }
        }
      });
    } else {
      const {WorkOrderProfile} = this.props;
      this.props.dispatch({
        type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
        params: {
          projectId: WorkOrderProfile.requestDetail.project.id,
          lotId: WorkOrderProfile.requestDetail.lot.id,
          tradeId: this.state.trade.value,
          param: {
            searchKey: '',
            selectedValue: ''
          }
        }
      });
    }
  }

  onSelectChange = (event, name) => {
    if (name === 'trade') {
      this.setState({[name]: event.value, chargedTo: null}, () => {
        this.fetchSubcontractor();
      });
    } else {
      this.setState({[name]: event.value});
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const {BackChargeProfile} = this.props;
    const formData = this.form.getValues();
    let {paymentDate} = this.state;
    if (paymentDate === '') {
      paymentDate = null;
    } else if (paymentDate) {
      paymentDate = formatTimezoneDateTime(paymentDate);
    } else {
      paymentDate = BackChargeProfile.paymentDate;
    }
    formData.paymentDate = paymentDate;
    formData.tradeId = this.state.trade ? this.state.trade.value : BackChargeProfile.trade.id;
    formData.subcontractorId = this.state.chargedTo ? this.state.chargedTo.value : BackChargeProfile.subcontractor.subcontractorId;
    formData.amount = decimalFixed(formData.amount);

    this.props.dispatch({
      type: WorkOrderActionType.EDIT_BACK_CHARGE_ASYNC,
      params: {
        data: formData,
        refNo: this.state.backChargeId,
        rfsId: this.state.rfsId
      },
      callback: () => {
        this.props.toggleEditMode();
      }
    });
  }

  onChangePaymentDate = (paymentDate) => {
    if (paymentDate) {
      if (moment(paymentDate, 'MM/DD/YYYY', true).isValid()) {
        this.setState({
          paymentDate,
          error: null
        });
      } else {
        this.setState({
          error: 'Invalid datetime.'
        });
      }
    } else {
      this.setState({
        paymentDate
      });
    }
  }

  render() {
    const {BackChargeProfile} = this.props;
    const disableSubmitButton = this.state.error;
    let { amount, paymentDate, reason } = BackChargeProfile;
    if (this.form) {
      amount = this.form.getValues().amount;
      reason = this.form.getValues().reason;
    }
    if (paymentDate) {
      paymentDate = moment(paymentDate).format('MM/DD/YYYY');
    }

    return (
      <div className='rfs-detail add-new-work-order'>

        <div className='subcontractor box-form-siteone'>
          <div className='box-form-body'>
            <Form ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
              <div className='row'>
                <div className='col-sm-4 col-xs-6'>
                  <div className='form-group'>
                    <label>Trade <span className='text-danger'> *</span></label>
                    <Dropdown
                      onChange={ref => { this.onSelectChange(ref, 'trade'); }}
                      className='filestring-dropdown filter-dropdown'
                      options={this.props.tradeSelectList}
                      loading={this.state.isLoadingGetTradeSelectList}
                      optionLabel='text'
                      // value={this.state.trade || {
                      //   value: BackChargeProfile.trade.id,
                      //   text: BackChargeProfile.trade.name,
                      //   extensionValue: null,
                      //   selected: false
                      // }}
                      value={this.state.trade}
                      showClear={false}
                      name='trade'
                      filter
                      placeholder='--Please select'
                      style={{ width: '100%', position: 'relative' }} />
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-sm-4 col-xs-6'>
                  <div className='form-group'>
                    <label>Charged to <span className='text-danger'> *</span></label>
                    <Dropdown
                      onChange={ref => { this.onSelectChange(ref, 'chargedTo'); }}
                      className='filestring-dropdown filter-dropdown'
                      options={this.props.subcontractorSelectList}
                      loading={this.state.isLoadingGetSubcontractorSelectList}
                      optionLabel='text'
                      filter
                      // value={this.state.chargedTo || {
                      //   value: BackChargeProfile.subcontractor.subcontractorId,
                      //   text: BackChargeProfile.subcontractor.companyName,
                      //   extensionValue: null,
                      //   selected: false
                      // }}
                      value={this.state.chargedTo}
                      showClear={false}
                      name='trade'
                      placeholder='--Please select'
                      style={{ width: '100%', position: 'relative' }} />
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-sm-4 col-xs-6'>
                  <div className='form-group'>
                    <label>Amount<span className='text-danger'> *</span></label>
                    <div style={{position: 'relative'}}>
                      <span className='addon-input'>$</span>
                      <Input
                        style={{paddingLeft: 20}}
                        type='text'
                        name='amount'
                        ref='amount'
                        className='form-control'
                        max='12'
                        value={amount.toString()}
                        maxLength='12'
                        errorMsg='Estimated amount is maximum 12 characters'
                        validations={[Vali.required, Vali.maxlength, Vali.isNumber]} />
                    </div>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-sm-10'>
                  <div className='form-group'>
                    <label>Reason for issuing PO<span className='text-danger'> *</span></label>
                    <Textarea
                      className='form-control'
                      name='reason'
                      ref='reason'
                      max='500'
                      value={reason}
                      maxLength='500'
                      errorMsg='Reson for issuing PO is maximum 500 characters'
                      style={{height: 70}}
                      validations={[Vali.required,Vali.maxlength]} />
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-sm-6'>
                  <div className='form-group row'>
                    <div className='col-lg-3 col-md-4 col-sm-4'>Issued date</div>
                    <div className='col-lg-9 col-md-8 col-sm-8'><strong>{moment(BackChargeProfile.issuedDate).format('MM/DD/YYYY')}</strong></div>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-sm-6'>
                  <div className='form-group row'>
                    <div className='col-lg-3 col-md-4 col-sm-4'>Issued by</div>
                    <div className='col-lg-9 col-md-8 col-sm-8'><strong>{BackChargeProfile.issuedByUser.displayName}</strong></div>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-sm-4 col-xs-6'>
                  <div className='form-group'>
                    <label>Payment received</label>
                    <Datetime
                      ref={ref => { this.paymentDate = ref; }}
                      name='paymentDate'
                      timeFormat={false}
                      inputProps={{ placeholder: 'mm/dd/yyyy' }}
                      value={this.state.paymentDate ? moment(this.state.paymentDate).format('MM/DD/YYYY') : paymentDate}
                      onChange={this.onChangePaymentDate} 
                      closeOnSelect={true}/>
                    {this.state.error &&
                    <span className='text-danger' style={{fontSize: 12}}>{this.state.error}</span>
                    }

                  </div>
                </div>
              </div>

              <div className='form-group' style={{ marginTop: 15 }}>
                <a className='btn btn-primary btn-siteone-default' onClick={this.props.toggleEditMode}>Cancel</a>
                <Submit className='btn btn-primary btn-submit btn-siteone' disabled={disableSubmitButton}>Save</Submit>
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tradeSelectList: state.LotStore.TradeList,
    subcontractorSelectList: state.SubcontractorStore.SubcontractorList,
    BackChargeProfile: state.WorkOrderReducer.BackChargeProfile,
    WorkOrderProfile: state.WorkOrderReducer.WorkOrderProfile
  };
};

export default connect(mapStateToProps)(AddBackCharge);



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/EditBackCharge.js